var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-overlay fade",class:{ show: _vm.shown }},[_c('div',{staticClass:"overlay"}),_c('font-awesome-icon',{attrs:{"icon":"fa-duotone fa-spinner","spin":"","size":"5x"}}),(_vm.text)?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }